import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { colors } from '@global/constants'

const BODY_FONT_SIZE = 18

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px 0;

  p {
    font-weight: bold;
  }

  a {
    color: ${colors.blue.main};
  }
`

interface Props {
  mainText: string
  helperText?: {
    text: string
    href?: string
  }
}

export const Body = ({ mainText, helperText }: Props) => {
  return (
    <Container>
      <Typography variant="body1" fontSize={BODY_FONT_SIZE}>
        {mainText}
      </Typography>
      {helperText && (
        <Typography variant="body1" fontSize={BODY_FONT_SIZE}>
          {helperText.href && <a href={helperText.href}>{helperText.text}</a>}
          {!helperText.href && helperText.text}
        </Typography>
      )}
    </Container>
  )
}
